import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../../theme';
import { absolute, flexCenter, spaceBetween } from '../../styles/mixins';
import { FA_SELECTOR } from '../../styles/variables';
import lightbulbOnImg from '../../resources/img/icons/lightbulb-on.png';
import lightbulbOffImg from '../../resources/img/icons/lightbulb-off.png';

export const useShipmentSensorWidgetsStyles = createStyles(
  ({ css, cx, token }) => {
    const batteryValue = cx(
      css({
        ...flexCenter(),
        marginBottom: ThemeSpaces.SPACE_MD,
        fontWeight: 900,
        fontSize: token.fontSizeHeading3,
        lineHeight: '28px',
        color: ThemeColors.COLOR_GREY5,
      })
    );
    const batteryPowerPartInner = cx(
      css({
        ...absolute(0),
        right: 'initial',
      })
    );
    return {
      shipmentSensorWidgets: {
        paddingTop: ThemeSpaces.SPACE_NORM,

        '> .ant-row': {
          marginBottom: -ThemeSpaces.SPACE_NORM_20,

          '> .ant-col': {
            marginBottom: ThemeSpaces.SPACE_NORM_20,
          },
        },
      },
      sensorDataCard: {
        position: 'relative',
        height: 188,
        ...flexCenter(),
      },
      gaugeContainer: {
        marginBottom: ThemeSpaces.SPACE_MD,
      },
      lastReport: {
        position: 'absolute',
        bottom: ThemeSpaces.SPACE_SM,
        left: 0,
        right: 0,
        textAlign: 'center',
        fontSize: ThemeFont.FONT_SIZE_XS,
        lineHeight: 1,
        fontWeight: 500,
        fontFamily: ThemeFont.FONT_FAMILY4,
      },
      batteryValue,
      batteryLow: {
        [`.${batteryValue}`]: {
          color: ThemeColors.COLOR_RED2,
        },
        [`.${batteryPowerPartInner}`]: {
          backgroundColor: ThemeColors.COLOR_RED2,
        },
      },
      batteryMedium: {
        [`.${batteryPowerPartInner}`]: {
          backgroundColor: ThemeColors.COLOR_ORANGE3,
        },
      },
      batteryHigh: {
        [`.${batteryPowerPartInner}`]: {
          backgroundColor: ThemeColors.COLOR_LIGHT_GREEN2,
        },
      },
      batteryContainer: {
        alignSelf: 'stretch',
        paddingTop: ThemeSpaces.SPACE_NORM_30,
      },
      batteryInnerContainer: {
        ...flexCenter(),
      },
      batteryOutline: {
        ...flexCenter(),
        width: 114,
        height: 50,
        borderRadius: token.borderRadius,
        border: `4px solid ${ThemeColors.COLOR_GREY6}`,
        padding: '3px 4px',
      },
      batteryRightPart: {
        width: 4,
        height: 28,
        borderRadius: token.borderRadiusSM,
        marginLeft: -3,
        border: `4px solid ${ThemeColors.COLOR_GREY6}`,
      },
      batteryState: {
        display: 'flex',
        position: 'relative',
        width: '100%',
        height: '100%',
      },
      batteryPowerPart: {
        position: 'relative',
        flex: 1,
        ...spaceBetween(5, 'horizontal'),

        '&::before': {
          content: "''",
          ...absolute(0),
          borderRadius: token.borderRadiusXS,
          border: `1px dashed ${ThemeColors.COLOR_GREY6}`,
        },
      },
      batteryPowerPartInner,
      lightTitle: {
        position: 'absolute',
        top: 10,
        fontSize: token.fontSizeLG,
        lineHeight: '19px',

        '&.on': {
          fontWeight: 500,
          color: ThemeColors.COLOR_RED2,
        },
        '&.off': {
          fontWeight: 'normal',
        },
      },
      lightImg: {
        '&.on': {
          backgroundImage: `url(${lightbulbOnImg})`,
          width: 101,
          height: 101,
        },
        '&.off': {
          marginTop: ThemeSpaces.SPACE_NORM,
          backgroundImage: `url(${lightbulbOffImg})`,
          width: 54,
          height: 85,
        },
      },
      temperatureValue: {
        position: 'absolute',
        top: ThemeSpaces.SPACE_XS,
        fontFamily: ThemeFont.FONT_FAMILY4,
        fontWeight: 500,
        fontSize: ThemeFont.FONT_SIZE_SM_MINUS,

        strong: {
          fontSize: token.fontSizeSM,
          width: 58,
          display: 'inline-block',
          verticalAlign: 'middle',
        },
        [FA_SELECTOR]: {
          fontSize: token.fontSizeLG,
          display: 'inline-block',
          verticalAlign: 'middle',
        },
      },
      temperatureMinValue: {
        left: ThemeSpaces.SPACE_NORM,
      },
      temperatureMaxValue: {
        right: ThemeSpaces.SPACE_NORM,
        textAlign: 'right',
      },
    };
  }
);
